import {
  panoModelCode,
  hotSpotCode,
  transitionCode,
  spotTagCode,
  aiTourCode,
  multiFloorCode,
  panoImageCode,
  modelAppCode,
  useInitModel,
  initPanoIamgeCode,
  panoImageApp,
  panoCssCode,
  cameraCode,
  spotCode,
  personGuideCode,
  flyGuideCode,
  panoVideoApp,
  initPanoVideoCode,
  videoCssCode,
  panoVideoCode,
  McokHtml,
} from "./react-code";
import { roamingConfigCode } from "./mockData";
import {
  panoCodeV,
  transitionCodeV,
  hotSpotCodeV,
  spotTagCodeV,
  aiTourCodeV,
  multiFloorCodeV,
  appCodeV,
  initModelCodeV,
  mainCodeV,
  cameraCodeV,
  spotCodeV,
  personGuideCodeV,
  flyGuideCodeV,
  panoImageCodeV,
  panoVideoCodeV,
  initPanoImageCodeV,
  initVideoModelCodeV,
} from "./vue-code";

const panoModelFile = {
  "/App.js": {
    code: modelAppCode,
  },
  "/public/index.html": {
    code: McokHtml,
    hidden: true,
  },
  "/src/useInitModel.tsx": {
    code: useInitModel,
  },
  "/src/mockData/roamingConfig.js": {
    code: roamingConfigCode,
    hidden: true
  },
};
const panoImageFile = {
  "/App.js": {
    code: panoImageApp,
    hidden: true,
  },
  "/public/index.html": {
    code: McokHtml,
    hidden: true,
  },
  "/src/useInitPanoImage.tsx": {
    code: initPanoIamgeCode,
  },
  "/src/Pano/index.css": {
    code: panoCssCode,
  },
};
const panoVideoFile = {
  "/App.js": {
    code: panoVideoApp,
    hidden: true,
  },
  "/public/index.html": {
    code: McokHtml,
    hidden: true,
  },
  "/src/useInitPanoVideo.tsx": {
    code: initPanoVideoCode,
  },
  "/src/Pano/index.css": {
    code: videoCssCode,
  },
};

export const reactTabsMap = [
  {
    name: "模型渲染",
    refName: "modelRender",
    codeString: panoModelCode,
    defaultFile: panoModelFile,
  },
  {
    name: "场景切换",
    refName: "transition",
    codeString: transitionCode,
    defaultFile: panoModelFile,
  },
  {
    name: "热点标注",
    refName: "hotSpot",
    codeString: hotSpotCode,
    defaultFile: panoModelFile,
  },
  {
    name: "场景标签",
    refName: "sceneTag",
    codeString: spotTagCode,
    defaultFile: panoModelFile,
  },
  {
    name: "智能导览",
    refName: "aiTour",
    codeString: aiTourCode,
    defaultFile: panoModelFile,
  },
  {
    name: "多楼层",
    refName: "multiFloor",
    codeString: multiFloorCode,
    defaultFile: panoModelFile,
  },
  {
    name: "相机",
    refName: "camera",
    codeString: cameraCode,
    defaultFile: panoModelFile,
  },
  {
    name: "地面点位",
    refName: "spot",
    codeString: spotCode,
    defaultFile: panoModelFile,
  },
  {
    name: "走路机器人",
    refName: "personGuide",
    codeString: personGuideCode,
    defaultFile: panoModelFile,
  },
  {
    name: "飞行导购",
    refName: "flyGuide",
    codeString: flyGuideCode,
    defaultFile: panoModelFile,
  },
  {
    name: "全景图",
    refName: "panoImage",
    codeString: panoImageCode,
    defaultFile: panoImageFile,
  },
  {
    name: "全景视频",
    refName: "panoVideo",
    codeString: panoVideoCode,
    defaultFile: panoVideoFile,
  },
];

// vue-code
const panoModelFileV = {
  "/src/main.js": {
    code: mainCodeV,
    hidden: true,
  },
  "/src/App.vue": {
    code: appCodeV,
  },
  "/src/init-model.vue": {
    code: initModelCodeV,
  },
  "/src/mockData/roamingConfig.js": {
    code: roamingConfigCode,
    hidden: true
  },
};
const panoImageFileV = {
  "/src/main.js": {
    code: mainCodeV,
    hidden: true,
  },
  "/src/App.vue": {
    code: appCodeV,
  },
  "/src/init-model.vue": {
    code: initPanoImageCodeV,
  },
};
const panoVideoFileV = {
  "/src/main.js": {
    code: mainCodeV,
    hidden: true,
  },
  "/src/App.vue": {
    code: appCodeV,
  },
  "/src/init-model.vue": {
    code: initVideoModelCodeV,
  },
};
export const vueTabsMap = [
  {
    name: "模型渲染",
    refName: "modelRender",
    codeString: panoCodeV,
    defaultFile: panoModelFileV,
  },
  {
    name: "场景切换",
    refName: "transition",
    codeString: transitionCodeV,
    defaultFile: panoModelFileV,
  },
  {
    name: "热点标注",
    refName: "hotSpot",
    codeString: hotSpotCodeV,
    defaultFile: panoModelFileV,
  },
  {
    name: "场景标签",
    refName: "sceneTag",
    defaultFile: panoModelFileV,
    codeString: spotTagCodeV,
  },
  {
    name: "智能导览",
    refName: "aiTour",
    codeString: aiTourCodeV,
    defaultFile: panoModelFileV,
  },
  {
    name: "多楼层",
    refName: "multiFloor",
    codeString: multiFloorCodeV,
    defaultFile: panoModelFileV,
  },
  {
    name: "相机",
    refName: "camera",
    codeString: cameraCodeV,
    defaultFile: panoModelFileV,
  },
  {
    name: "地面点位",
    refName: "spot",
    codeString: spotCodeV,
    defaultFile: panoModelFileV,
  },
  {
    name: "走路机器人",
    refName: "personGuide",
    codeString: personGuideCodeV,
    defaultFile: panoModelFileV,
  },
  {
    name: "飞行导购",
    refName: "flyGuide",
    codeString: flyGuideCodeV,
    defaultFile: panoModelFileV,
  },
  {
    name: "全景图",
    refName: "panoImage",
    codeString: panoImageCodeV,
    defaultFile: panoImageFileV,
  },
  {
    name: "全景视频",
    refName: "panoVideo",
    codeString: panoVideoCodeV,
    defaultFile: panoVideoFileV,
  },
];
